import { createFileRoute } from "@tanstack/react-router";
import { PillarPage } from "@/components/site/PillarPage";
import { faqJsonLd, serviceJsonLd } from "@/lib/seo.schemas";

const FAQ = [
  { q: "Vad kostar ett studentfirande?", a: "För ett gymnasium med 200–400 avgångselever ligger ett studentfirande oftast 25 000–60 000 kr beroende på programpunkter, scen och fun food. Vi ger alltid pris via mejl." },
  { q: "Kan ni hantera utskolningen?", a: "Ja. Vi kan bygga scen vid utskolningsplatsen, ljud för rektor och DJ, fotostation och fun food. Allt klart i god tid innan första klassen springer ut." },
  { q: "Vilka karaktiviteter passar gymnasiet?", a: "Lyckohjul, gladiator-pugil, Wipeout, brandade tävlingar och fun food. För större elev­fester: scen, ljud, ljus och en interaktiv kompis-utmaning som engagerar hela aulan." },
];

export const Route = createFileRoute("/gymnasium/")({
  head: () => ({
    meta: [
      { title: "Studentfirande & karaktiviteter för gymnasium | Event Sverige" },
      { name: "description", content: "Studentfirande, utskolning och elevkårsaktiviteter för gymnasier. Scen, fun food, hoppborgar och fotostation. Pris via mejl." },
      { property: "og:title", content: "Gymnasium — studentfirande & elevkår" },
      { property: "og:description", content: "Vi hjälper gymnasiet göra studenten oförglömlig — utan att lärarna behöver stå för logistiken." },
      { property: "og:url", content: "/gymnasium" },
    ],
    links: [{ rel: "canonical", href: "https://eventsverige.se/gymnasium" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(faqJsonLd(FAQ)) },
      { type: "application/ld+json", children: JSON.stringify(serviceJsonLd("Gymnasieaktiviteter", "Studentfirande, utskolning och elevkårsfest.", "/gymnasium")) },
    ],
  }),
  component: GymPillar,
});

function GymPillar() {
  return (
    <PillarPage
      eyebrow="För gymnasieskolan"
      h1="Studentfirande och elevkårsfester som klassen kommer minnas"
      intro="Studenten är livets största firande för de flesta gymnasister. Vi hjälper er bygga utskolning, kårfest, idrottsdag eller temadag som matchar elevkårens energi och rektorns budget. Vi levererar, bemannar och städar — ni får en oförglömlig dag utan en stressad lärarstab."
      whyUs={[
        "Scen, ljud och ljus för utskolning och bal — proffsig kvalitet utan stora bolagspriser.",
        "Brandade tävlingar och fun food i skolans färger eller programmets symboler.",
        "Vana vid stora elevvolymer och täta tidsfönster runt studentdagen.",
        "Hjälp att fördela kostnad mellan elevkår, skolfond och avgångsklasser.",
      ]}
      subPages={[
        { to: "/forfragan", title: "Studentfirande", description: "Utskolning, scen, ljud, fotostation och fun food. Vi packar färgerna." },
        { to: "/forfragan", title: "Karaktiviteter", description: "Pub, sittning, valborgsfest eller elevkårens årliga storfest." },
      ]}
      concepts={[
        { size: "Utskolning", title: "Studentpaket", description: "Scen + ljud för rektor, fotostation, popcorn och en glassmaskin. Klart 30 min innan studenterna springer ut." },
        { size: "Avslutningsbal", title: "Bal & afterparty", description: "DJ-utrustning, LED-scen, lyckohjul med vinster och brandade tävlingar mellan klasserna." },
        { size: "Elevkårsfest", title: "Kårens årshöjdpunkt", description: "Fyra aktiviteter, fun food och en interaktiv kompis-utmaning som engagerar hela aulan." },
      ]}
      budget={[
        { range: "10–20 tkr", label: "Mindre paket", description: "Scen + ljud för rektor och en aktivitet.", includes: ["Scen", "Ljud", "1 aktivitet"] },
        { range: "20–40 tkr", label: "Studentpaket", description: "Komplett utskolning med fotostation och fun food.", includes: ["Scen + ljud", "Fotostation", "Fun food"] },
        { range: "40–80 tkr", label: "Bal / storfest", description: "DJ, LED, brandade vinster, full bemanning.", includes: ["DJ + LED", "Tävlingar", "Full bemanning"] },
      ]}
      faq={FAQ}
      ctaText="Begär offert för gymnasiet"
    />
  );
}
